"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixXrightarrow = fixXrightarrow;
const tex_syntax_1 = require("./tex-syntax");
function fixXrightarrow(tex) {
    const xrightarrowWithUnbracedTextArg = new RegExp(`(\\\\xrightarrow\\s*(?:\\[[^\\]]*]\\s*)?)(\\\\text${(0, tex_syntax_1.block)(0)})`, "g");
    return tex.replace(xrightarrowWithUnbracedTextArg, "$1{$2}");
}
